import { render } from "./FeaturedCommunities.vue?vue&type=template&id=92cc92fa"
import script from "./FeaturedCommunities.vue?vue&type=script&lang=js"
export * from "./FeaturedCommunities.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/mydid-badgechecker-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__